import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import CurrencySymbol from 'components/ui/CurrencySymbol';

import { TrainMarginTable, TrainMarginHead, TrainMarginBody } from './TrainMargin.styles';

const TrainMargin = ({ product }) => {
  const productStatus = () => {
    if (product.isCancelled) {
      return <FormattedMessage id="bookingStatus.cancelled" />;
    }

    if (product.isPendingCancellation) {
      return <FormattedMessage id="bookingStatus.temporallyCancelled" />;
    }

    return <FormattedMessage id="bookingStatus.confirmed" />;
  };

  return (
    <TrainMarginTable>
      <TrainMarginHead>
        <tr>
          <th>
            <FormattedMessage id="fareProducts.product" />
          </th>
          <th>
            <FormattedMessage id="trainMargin.price" />
          </th>
          <th>
            <FormattedMessage id="journeySegment.status" />
          </th>
        </tr>
      </TrainMarginHead>
      <TrainMarginBody>
        <tr>
          <td>EHL Train Margin</td>
          <td>
            <CurrencySymbol currencyCode={product.currency} />
            {product.price}
          </td>
          <td>{productStatus()}</td>
        </tr>
      </TrainMarginBody>
    </TrainMarginTable>
  );
};

TrainMargin.propTypes = {
  product: PropTypes.shape({
    currency: PropTypes.string,
    price: PropTypes.number,
    isCancelled: PropTypes.bool,
    isPendingCancellation: PropTypes.bool
  })
};

export default TrainMargin;
